export { AccommodationListTemplate } from './AccommodationListTemplate';
export type {
  AccommodationListItem,
  AccommodationListTemplateProps,
} from './AccommodationListTemplate.types';
